import { UserCheck, Handshake, Brain, Search, ArrowUpRight } from "lucide-react";
import { RevealOnScroll } from "./RevealText";
import { useCaseIcons, useCaseIds } from "../data/staticData";
import { useLanguage } from "../i18n/LanguageContext";

const icons = { UserCheck, Handshake, Brain, Search };

export function UseCases() {
  const { t } = useLanguage();
  return (
    <section id="use-cases" className="relative py-24 lg:py-32 bg-[#0A0A0C]" data-testid="use-cases-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <RevealOnScroll className="max-w-2xl mb-16">
          <span className="font-mono-data text-xs text-[#00F0FF]">/ {t.nav.useCases.toUpperCase()}</span>
          <h2 className="mt-4 font-display font-bold text-4xl sm:text-5xl text-white tracking-tighter">
            {t.useCases.title}
          </h2>
          <p className="mt-4 text-zinc-400 text-base sm:text-lg">{t.useCases.subtitle}</p>
        </RevealOnScroll>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {t.useCases.items.map((u, i) => {
            const Icon = icons[useCaseIcons[i]];
            return (
              <RevealOnScroll key={useCaseIds[i]} delay={(i % 2) * 0.1}>
                <div
                  className="group relative rounded-2xl border border-white/10 p-8 hover:border-[#00F0FF]/30 hover:-translate-y-1 transition-all duration-300 bg-[#050505]"
                  data-testid={`use-case-card-${useCaseIds[i]}`}
                >
                  <Icon className="w-7 h-7 text-[#00F0FF]" strokeWidth={1.5} />
                  <h3 className="mt-5 font-display font-semibold text-lg text-white leading-snug">{u.title}</h3>

                  <div className="mt-5 space-y-3 text-sm">
                    <p className="text-zinc-500"><span className="text-zinc-400 font-medium">{u.problem}</span></p>
                    <p className="text-zinc-500">{u.solution}</p>
                  </div>

                  <div className="mt-5 pt-5 border-t border-white/10 flex items-center justify-between">
                    <span className="text-sm font-medium text-[#00FF66]">{u.result}</span>
                    <ArrowUpRight className="w-4 h-4 text-zinc-500 group-hover:text-[#00F0FF] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-200" />
                  </div>
                </div>
              </RevealOnScroll>
            );
          })}
        </div>
      </div>
    </section>
  );
}
